import styled, { css } from 'styled-components'

import { COLOURS } from 'resources'

import RoundedButton from 'components/RoundedButton'
import { ReactComponent as exclamationRed } from 'resources/images/icons/exclamation-icon-red.svg'
import { ReactComponent as infoGreyIcon } from 'resources/images/icons/info-grey.svg'
import { ReactComponent as infoRedOutlineIcon } from 'resources/images/icons/info-red-outline-icon.svg'

// Common Styles
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: 100%;
  margin-top: 30px;
`
export const ContinueButton = styled(RoundedButton)``

export const Icon = styled.img`
  height: 38px;
  width: 38px;
  margin-right: 9px;
`
export const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
`

// PointsConversionScreen
export const PointsContainer = styled.div`
  width: 100%;
`

export const PointsConversionTitleSection = styled.div`
  display: flex;
  align-items: center;
  margin: 15px 0;
`

export const PointsConversionCardTitle = styled.div`
  font-family: 'Druk', sans-serif;
  line-height: 1;
  font-size: 36px;
  color: ${COLOURS.neutralBlack};
  text-transform: uppercase;
`

export const PointsConversionScreenTitle = styled.div`
  font-family: 'Druk', sans-serif;
  font-size: 70px;
  line-height: 1;
  color: ${COLOURS.neutralWhite};
  background-color: ${COLOURS.neutralBlack};
  align-self: flex-start;
`
export const ConvertedPointsContainer = styled.div`
  height: 48px;
  border: 0 solid ${COLOURS.neutralBlack};
  border-bottom-width: 2px;
  border-radius: 0;
  font-size: 16px;
  padding: 11px;
  margin-top: 14px;
  width: 100%;
  margin-bottom: 42px;
  background-color: ${COLOURS.lightGrey6};
`

export const ApproximateText = styled.span`
  color: ${COLOURS.neutralBlack};
  opacity: 0.7;
  margin-left: 3px;
`
export const ErrorFeedback = styled.div`
  margin: -30px 0 16px;
  color: ${COLOURS.errorText};
`

export const ExclamationContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
`
export const ExclamationDescription = styled.div`
  font-size: 16px;
  color: ${COLOURS.neutralGrey5};
`

export const InfoIconRed = styled(infoRedOutlineIcon)`
  width: 50px;
  margin-right: 5px;
  align-self: flex-start;
`

export const PasteAddressButton = styled(RoundedButton)`
  margin-top: 20px;
`

// Confirmation Screen
export const ConfirmationScreenTitle = styled.div`
  font-family: 'DRUK', sans-serif;
  line-height: 1;
  font-size: 30px;
  color: ${COLOURS.neutralBlack};
  margin-bottom: 18px;
`

export const ConfirmationScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: 100%;
`

const SectionStyles = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0;
  padding-left: 0;
  width: 100%;
`

export const ConfirmationScreenSection = styled.div`
  ${SectionStyles}
  height: 48px;
  flex-direction: row;
`
export const SectionBoldText = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: ${COLOURS.neutralBlack};
`
export const SectionText = styled.div`
  font-size: 20px;
  color: ${COLOURS.neutralBlack};
`
export const TextIconSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ExclamationIcon = styled(infoGreyIcon)`
  height: 16px;
  width: 16px;
  path {
    fill: ${COLOURS.neutralBlack};
  }
`
export const ExclamationButton = styled.button`
  display: flex;
  border: none;
  background-color: ${COLOURS.neutralWhite};
`
export const NetworkFeeSection = styled.div`
  ${SectionStyles}
  flex-direction: column;
  padding-top: 10px;
`
export const NetworkFeeRowSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`
export const WalletTitle = styled.div`
  font-size: 16px;
  color: ${COLOURS.neutralGrey4};
  margin-bottom: 7px;
`
export const WalletText = styled.div`
  font-size: 18px;
  color: ${COLOURS.neutralBlack};
  border-bottom: 2px solid ${COLOURS.neutralBlack};
  margin-bottom: 30px;
  word-break: break-word;
`
export const CryptoToReceiveSection = styled.div`
  background-color: ${COLOURS.white};
  align-items: center;
  height: 60px;
  border-radius: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-top: 25px;
  border-top: 1px solid ${COLOURS.neutralGrey2};
`
export const CryptoToReceiveSectionText = styled.div`
  font-size: 20px;
  color: ${COLOURS.neutralBlack};
`
export const CryptoToReceiveIconSection = styled.div`
  display: flex;
  flex-direction: row;
`
export const ErrorMessage = styled.div`
  color: ${COLOURS.secondaryRed1};
`
export const ExclamationIconRed = styled(exclamationRed)`
  margin-right: 10px;
  align-self: flex-start;
`
export const ConfirmationWarningContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
`
export const ConfirmationWarningDescription = styled.div`
  font-size: 16px;
  color: ${COLOURS.secondaryRed1};
`

export const PolygonWarningContainer = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${COLOURS.neutralBlack};
  word-break: break-word;
`
